// 生成合并单元格数据
export function generateMergeCells(data, key, cols) {
  if (data.length === 0) return []
  let pointer = 0
  let total = 0
  let curKeyValue = data[0][key]
  const result = data.reduce((acc, cur, index) => {
    const val = cur[key]
    let mergeData = []
    if (val !== curKeyValue) {
      // 生成合并数据
      if (total > 1) {
        mergeData = generateCells(cols, pointer, total)
      }
      curKeyValue = val
      pointer = index // 指针index赋值
      total = 1
    } else {
      total += 1
      if (index === data.length - 1) {
        mergeData = generateCells(cols, pointer, total)
      }
    }
    acc.push(...mergeData)
    return acc
  }, [])
  return result
}


// 多个key生成合并单元格数据 
export function generateMergeCellsByKeyList(data, keyList, colsList) {
  if (data.length === 0) return []
  let resultList =[]
  keyList.forEach((key,keyIndex)=>{
    let cols = colsList[keyIndex]
    let pointer = 0
    let total = 0
    let curKeyValue = data[0][key]
    const result = data.reduce((acc, cur, index) => {
      const val = cur[key]
      let mergeData = []
      if (val !== curKeyValue) {
        // 生成合并数据
        if (total > 1) {
          mergeData = generateCells(cols, pointer, total)
        }
        curKeyValue = val
        pointer = index // 指针index赋值
        total = 1
      } else {
        total += 1
        if (index === data.length - 1) {
          mergeData = generateCells(cols, pointer, total)
        }
      }
      acc.push(...mergeData)
      return acc
    }, [])
    resultList.push(...result)
  })

  return resultList
}


export function generateCells(cols, rowIndex, rowspan) {
  return cols.map((col) => {
    return {
      row: rowIndex,
      col,
      rowspan,
      colspan: 1
    }
  })
}
